
import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/deposit/payou';
import {clearSquareOrder} from '../../../../reducers/app/actions';
import {useLocation} from 'react-router-dom';

import Enter from './enter';
import Alert from './alert';

export default ({setMethod}) => {
    const {order, button} = useSelector(Selector),
          location = useLocation(),
          dispatch = useDispatch();

    useLocation(() => {
        return () => dispatch(clearSquareOrder());
    }, [location]);

    if(!order)
        return <Enter setMethod={setMethod} button={button} />

    return <Alert order={order} />
}